

const upcomingEvents = [
  {
    id: "webinar-001",
    mainHeadline:
      "Manufacturing Smarter -Discover how to Streamline operations and accelerate growth ",
    subHeadline:
      "No matter your ERP -Infor MES fits right in. It's a solution-agnostic design ensures effortless integration and maximum flexibility.",
    eventDate: "June 18, 2025",
    time: "2:00 PM - 3:00 PM IST",
    location: "Virtual Event",
    briefDescription: `Are you ready to elevate your manufacturing operations to the next level?
Join us for an insightful and interactive session on Infor MES (Manufacturing Execution System) — the digital backbone of smart factories.`,
    smallDescription:
      "Discover how Infor MES creates a paperless shopfloor with real-time visibility and control.",
    whyAttend: [
      "Discover how Infor MES enables real-time production monitoring and visibility.",
      "Learn how to bridge the gap between planning and execution",
      "Explore success stories and use cases from industry leaders",
      "Live Q&A with product experts",
    ],
    WhoShouldAttend: {
      title: "Who Should Attend",
      description:
        "If you're looking to streamline shop floor operations, improve throughput, and embrace Industry 4.0, this webinar is for you.",
      audience: [
        "Manufacturing Leaders",
        "Plant Managers",
        "IT Decision Makers",
        "ERP Consultants",
       
       
      ],
    },
    speakerIntroductions: [
      {
        name: "Michael Roberts",
        title: "Solutions Architect, Infor MES",
        bio: "Michael specializes in helping manufacturers implement digital solutions that drive operational excellence and shopfloor productivity.",
      },
      {
        name: "Jennifer Chen",
        title: "Manufacturing Digital Transformation Lead, Infor",
        bio: "Jennifer has guided numerous manufacturers through their digital transformation journey using Infor MES solutions.",
      },
    ],
    registrationLink: "https://infor.com/register/mes-webinar",
    ticketPrice: "Complimentary",
    category: "Manufacturing Technology",
    imageUrl: "/images/events/infor-mes-webinar.jpg",
    agenda: [
      {
        time: "2:00 PM - 2:10 AM",
        activity: "Introduction and Manufacturing Challenges Overview",
      },
      {
        time: "2:10 AM - 2:30 AM",
        activity: "Infor MES Solution Architecture",
      },
      {
        time: "2:30 AM - 2:40 AM",
        activity: "Composable MES Modules Deep Dive",
      },
      {
        time: "2:40 AM - 2:50 AM",
        activity: "Implementation Approach and User Experience",
      },
      {
        time: "2:50 AM - 3:00 AM",
        activity: "Q&A Session",
      },
    ],
    
  },
];

const pastEvents = [
//   {
//     id: "webinarPast-001",
//     mainHeadline:
//       "Infor Mes ",
//     subHeadline:
//       "No matter your ERP -Infor MES fits right in. It's a solution-agnostic design ensures effortless integration and maximum flexibility.",
//     eventDate: "Jan 18, 2024",
//     time: "12:00 PM - 1:00 PM IST",
//     location: "Virtual Event",
//     briefDescription: `Are you ready to elevate your manufacturing operations to the next level?
// Join us for an insightful and interactive session on Infor MES (Manufacturing Execution System) — the digital backbone of smart factories.`,
//     smallDescription:
//       "Discover how Infor MES creates a paperless shopfloor with real-time visibility and control.",
//     whyAttend: [
//       "Discover how Infor MES enables real-time production monitoring and visibility.",
//       "Learn how to bridge the gap between planning and execution",
//       "Explore success stories and use cases from industry leaders",
//       "Live Q&A with product experts",
//     ],
//     WhoShouldAttend: {
//       title: "Who Should Attend",
//       description:
//         "If you're looking to streamline shop floor operations, improve throughput, and embrace Industry 4.0, this webinar is for you.",
//       audience: [
//         "Manufacturing Leaders",
//         "Plant Managers",
//         "IT Decision Makers",
//         "ERP Consultants",
//       ],
//     },
//     speakerIntroductions: [
//       {
//         name: "Michael Roberts",
//         title: "Solutions Architect, Infor MES",
//         bio: "Michael specializes in helping manufacturers implement digital solutions that drive operational excellence and shopfloor productivity.",
//       },
//       {
//         name: "Jennifer Chen",
//         title: "Manufacturing Digital Transformation Lead, Infor",
//         bio: "Jennifer has guided numerous manufacturers through their digital transformation journey using Infor MES solutions.",
//       },
//     ],
//     registrationLink: "https://infor.com/register/mes-webinar",
//     ticketPrice: "Complimentary",
//     category: "Manufacturing Technology",
//     imageUrl: "/images/events/infor-mes-webinar.jpg",
//     agenda: [
//       {
//         time: "2:00 PM - 2:10 AM",
//         activity: "Introduction and Manufacturing Challenges Overview",
//       },
//       {
//         time: "2:10 AM - 2:30 AM",
//         activity: "Infor MES Solution Architecture",
//       },
//       {
//         time: "2:30 AM - 2:40 AM",
//         activity: "Composable MES Modules Deep Dive",
//       },
//       {
//         time: "2:40 AM - 2:50 AM",
//         activity: "Implementation Approach and User Experience",
//       },
//       {
//         time: "2:50 AM - 3:00 AM",
//         activity: "Q&A Session",
//       },
//     ],
//   },
  // {
  //   id: "past-002",
  //   mainHeadline: "Digital Marketing Masterclass",
  //   subHeadline: "Strategies for the Modern Marketer",
  //   eventDate: "September 5, 2024",
  //   time: "1:00 PM - 6:00 PM EST",
  //   location: "Marketing Hub, New York, NY",
  //   briefDescription: "An intensive half-day workshop covering the latest digital marketing strategies, tools, and best practices for today's competitive landscape.",
  //   smallDescription: "Expert-led workshop on cutting-edge digital marketing techniques.",
  //   keyTakeaways: [
  //     "Advanced social media marketing tactics",
  //     "Data-driven marketing decision making",
  //     "Emerging trends in content marketing"
  //   ],
  //   speakerIntroductions: [
  //     {
  //       name: "Alicia Torres",
  //       title: "Chief Marketing Officer, DigitalEdge",
  //       bio: "Alicia has led marketing campaigns for Fortune 500 companies and startups alike, specializing in digital transformation."
  //     }
  //   ],
  //   highlights: [
  //     "Interactive workshop on SEO optimization",
  //     "Case study presentations of successful campaigns",
  //     "Personalized marketing strategy consultations"
  //   ],
  //   attendeeCount: 120,
  //   feedbackRating: 4.8,
  //   resourcePackage: "https://example.com/resources/marketing-masterclass"
  // },
];

const featuredEvents = [
  
];


export { upcomingEvents, pastEvents, featuredEvents };